<template>
<div id="shiori-howto">
  <h2>サイトの使い方</h2>
  <div>
    <h3><span>01</span>しおりを作ろう</h3>
    <p><a @click.prevent="toShioriTitle">トップページ</a>でしおりのタイトルを決めて、
    概要・持ち物・旅程を入力していこう！<br>
    ※現時点ではリロードすると今までの入力がすべて消えてしまいます。</p>
  </div>
  <div>
    <h3><span>02</span>完成したらみんなに共有しよう</h3>
    <p>※現在準備中です。</p>
  </div>
  <div>
    <h3><span>03</span>ログイン機能でいつでも編集可能</h3>
    <p>※現在準備中です。</p>
  </div>
  <div id="howto-info">
    <h3 class="info-title">※注意※</h3>
    <p>連絡先や予約番号など個人情報の記載には十分ご注意ください。</p>
  </div>
  <div id="top-page">
    <a @click.prevent="toShioriTitle">トップへ戻る</a>
  </div>
  <div class="sub-footer" v-show="underNav">
    <p>© 2020 Tabi no Shiori</p>
  </div>
</div>
</template>

<script>
export default {
  props: {
    underNav: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toShioriTitle() {
      this.$router.push("/");
    }
  }
}
</script>